import { ApiRequest } from "src/models/api.request";
import VwGnlRoldbKullaniciDTO from "src/models/RolYetki/VwGnlRoldbKullaniciDTO";
import api from "src/services/core/api";

const controllerName = "VwGnlRoldbKullaniciDTO";

export const rolDbApi = api.injectEndpoints({
    endpoints: builder => ({
        getGnlRoldbKullanici: builder.query<Array<VwGnlRoldbKullaniciDTO>, {
            kullaniciId: number,
            bagliorganizasyonId?: number,
            vtysgrup: number
        }>({
            query: (request) => {
                const apiRequest: ApiRequest<VwGnlRoldbKullaniciDTO> = {
                    paging: false,
                    filters: {
                        groupOperator: "and",
                        predicates: []
                    },
                    sorts: [{ fieldName: "adi" }]
                }
                if (request?.kullaniciId > 0)
                    apiRequest.filters.predicates.push({ fieldName: "kullaniciId", operator: "=", value1: request.kullaniciId });
                if (request?.bagliorganizasyonId > 0)
                    apiRequest.filters.predicates.push({ fieldName: "bagliorganizasyonId", operator: "=", value1: request.bagliorganizasyonId });
                if (request?.vtysgrup > 0)
                    apiRequest.filters.predicates.push({ fieldName: "vtysgrup", operator: "=", value1: request.vtysgrup });

                return {
                    url: controllerName + "/find",
                    method: "POST",
                    body: JSON.stringify(apiRequest)
                }
            },
            providesTags: ["RolDbKullanici"]
        })
    }),
})

export const { useGetGnlRoldbKullaniciQuery } = rolDbApi;